"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecordTypesT = exports.OpenAttestationDNSTextRecordT = exports.EthereumNetworks = exports.EthereumNetworkIdT = exports.EthereumAddressT = exports.BlockchainNetworkT = void 0;
var _runtypes = require("runtypes");
const RecordTypesT = exports.RecordTypesT = (0, _runtypes.Literal)("openatts");
const BlockchainNetworkT = exports.BlockchainNetworkT = (0, _runtypes.Literal)("ethereum");
const EthereumAddressT = exports.EthereumAddressT = _runtypes.String.withConstraint(maybeAddress => {
  return /0x[a-fA-F0-9]{40}/.test(maybeAddress) || `${maybeAddress} is not a valid ethereum address`;
});
let EthereumNetworks = exports.EthereumNetworks = void 0;
(function (EthereumNetworks) {
  EthereumNetworks["homestead"] = "1";
  EthereumNetworks["ropsten"] = "3";
  EthereumNetworks["rinkeby"] = "4";
  EthereumNetworks["goerli"] = "5";
  EthereumNetworks["sepolia"] = "11155111";
  EthereumNetworks["polygon"] = "137";
  EthereumNetworks["polygonAmoy"] = "80002";
  EthereumNetworks["local"] = "1337";
  EthereumNetworks["xdc"] = "50";
  EthereumNetworks["xdcapothem"] = "51";
  EthereumNetworks["stabilityTestnet"] = "20180427";
  EthereumNetworks["stability"] = "101010";
  EthereumNetworks["astronTestnet"] = "21002";
  EthereumNetworks["astron"] = "1338";
})(EthereumNetworks || (exports.EthereumNetworks = EthereumNetworks = {}));
const EthereumNetworkIdT = exports.EthereumNetworkIdT = (0, _runtypes.Union)((0, _runtypes.Literal)(EthereumNetworks.homestead), (0, _runtypes.Literal)(EthereumNetworks.ropsten), (0, _runtypes.Literal)(EthereumNetworks.rinkeby), (0, _runtypes.Literal)(EthereumNetworks.goerli), (0, _runtypes.Literal)(EthereumNetworks.sepolia), (0, _runtypes.Literal)(EthereumNetworks.polygon), (0, _runtypes.Literal)(EthereumNetworks.polygonAmoy), (0, _runtypes.Literal)(EthereumNetworks.xdc), (0, _runtypes.Literal)(EthereumNetworks.xdcapothem), (0, _runtypes.Literal)(EthereumNetworks.stabilityTestnet), (0, _runtypes.Literal)(EthereumNetworks.stability), (0, _runtypes.Literal)(EthereumNetworks.local), (0, _runtypes.Literal)(EthereumNetworks.astronTestnet), (0, _runtypes.Literal)(EthereumNetworks.astron));
const OpenAttestationDNSTextRecordT = exports.OpenAttestationDNSTextRecordT = (0, _runtypes.Record)({
  type: RecordTypesT,
  net: BlockchainNetworkT,
  netId: EthereumNetworkIdT,
  addr: EthereumAddressT
}).And((0, _runtypes.Partial)({
  dnssec: _runtypes.Boolean
}));